<template>
	<BoxList v-loading="loading">
		<template v-slot:form>
			<el-form
				size="small"
				:inline="true"
				label-position="right"
				label-width="140px"
			>
				<el-col :span="8">
					<el-form-item label="维修服务单号">
						<el-input v-model.trim="form.vRepairNo" clearable></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="维修手机号码">
						<el-input
							v-model.trim="form.vContactTelephone"
							maxlength="11"
							clearable
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="维修地址">
						<el-input
							v-model.trim="form.vVisitRepairAddress"
							maxlength="address"
							clearable
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="客户姓名">
						<el-input
							v-model.trim="form.vContactName"
							maxlength="8"
							clearable
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="渠道类型">
						<el-select v-model="form.channelId" filterable multiple clearable>
							<el-option
								v-for="item in channelList"
								:key="item.channelId"
								:label="item.channelName"
								:value="item.channelId"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="审核状态">
						<el-select v-model="form.iAuditStatus" filterable clearable>
							<el-option
								v-for="item in $constants.auditstatus"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="维修状态">
						<el-select v-model="form.iRepairStatus" filterable clearable>
							<el-option
								v-for="item in $constants.repairstatus"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="维修审核结果">
						<el-select v-model="form.iBackRepairAudit" filterable clearable>
							<el-option
								v-for="item in $constants.backIsOr"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="上门维修信息">
						<el-select v-model="form.iBackRepairVisit" filterable clearable>
							<el-option
								v-for="item in $constants.backIsOr"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="维修服务结果">
						<el-select v-model="form.iBackRepairResult" filterable clearable>
							<el-option
								v-for="item in $constants.backIsOr"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="16">
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="time"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							@change="timeChange"
							style="width: 100%"
						>
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label=" ">
						<el-button type="primary" @click="seanch">查询</el-button>
					</el-form-item>
				</el-col>
			</el-form>
		</template>
		<template v-slot:show>
			<el-table
				:data="list"
				size="small"
				row-key="pkFacilityRepairOrderId"
				border
				fit
				stripe
				:max-height="tableHeight"
				style="width: 100%"
			>
				<!-- <el-table-column align="center" type="index" width="50">
				</el-table-column> -->
				<!-- <el-table-column prop="name" label="渠道类型"> </el-table-column> -->
				<el-table-column
					width="150px"
					prop="vrepairNo"
					label="维修单号"
					align="center"
				>
					<template slot-scope="scope">
						<el-link
							v-if="$init.hasPower(`/process/list##R`)"
							type="primary"
							@click="rowView(scope.row)"
							>{{ scope.row.vrepairNo }}</el-link
						>
						<span v-else>{{ scope.row.vrepairNo }}</span>
					</template>
				</el-table-column>
				<el-table-column
					width="140px"
					prop="vsourceTypeName"
					label="渠道类型"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="110px"
					prop="vcontactName"
					label="联系人姓名"
					align="center"
				>
				</el-table-column>
				<el-table-column
					width="120px"
					prop="vcontactTelephone"
					label="联系人手机号码"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="dcreatetime"
					label="创建时间"
					width="150"
					align="center"
				>
					<template slot-scope="scope">
						<span>{{ $utils.timeFormat(scope.row.dcreatetime) }}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="iauditstatusName"
					label="审核状态"
					width="100"
					align="center"
				>
					<template slot-scope="scope">
						<!-- :style="{
								color: $constants.getColor('backIsOr', scope.row.iBackRepairVisit),
							}" -->
						<span>{{
							$constants.getLabel("auditstatus", scope.row.iauditStatus)
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="irepairStatus"
					label="维修状态"
					width="100"
					align="center"
				>
					<template slot-scope="scope">
						<!-- :style="{
								color: $constants.getColor('backIsOr', scope.row.iBackRepairVisit),
							}" -->
						<span>{{
							$constants.getLabel("repairstatus", scope.row.irepairStatus)
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="isCancel"
					label="取消状态"
					min-width="100"
					align="center"
				>
					<template slot-scope="scope">
						<span v-show="scope.row.isCancel == 1" style="font-weight: 500"
							>已取消</span
						>
						<span v-show="scope.row.isCancel == 0">未取消</span>
					</template>
				</el-table-column>

				<el-table-column
					prop="vvisitRepairAddress"
					label="维修地址"
					width="180"
					header-align="center"
				>
				</el-table-column>
				<el-table-column
					prop="ibackRepairAudit"
					label="是否回传维修审核结果"
					min-width="120"
					align="center"
				>
					<template slot-scope="scope">
						<span>{{
							$constants.getLabel("backIsOr", scope.row.ibackRepairAudit)
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="ibackRepairVisit"
					label="是否回传上门维修信息"
					min-width="120"
					align="center"
				>
					<template slot-scope="scope">
						<!-- :style="{
								color: $constants.getColor('backIsOr', scope.row.iBackRepairVisit),
							}" -->
						<span>{{
							$constants.getLabel("backIsOr", scope.row.ibackRepairVisit)
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="ibackRepairResult"
					label="是否回传维修服务结果"
					min-width="120"
					align="center"
				>
					<template slot-scope="scope">
						<span>{{
							$constants.getLabel("backIsOr", scope.row.ibackRepairResult)
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="vremark"
					label="备注"
					min-width="120"
					header-align="center"
				></el-table-column>

				<!-- <el-table-column width="144px" prop="operatorTime" label="维修时间">
				</el-table-column> -->

				<el-table-column
					fixed="right"
					width="110px"
					label="操作"
					align="center"
				>
					<template slot-scope="scope">
						<!-- v-if="$init.hasPower(`/process/list##SH`)" -->
						<el-button @click="rowView(scope.row)" type="text" size="small">
							详情
						</el-button>
						<!-- v-if="$init.hasPower(`/process/list##SH`)" -->
						<el-button
							v-if="$init.hasPower(`/overhaul/overhaulList##WXSH`)"
							v-show="scope.row.iauditStatus == 1 && scope.row.isCancel != 1"
							@click="openTrigger(scope.row)"
							type="text"
							size="small"
						>
							审核
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Page
				:pageNo="page.no"
				:pageSize="page.size"
				:pageCount="page.count"
				@pageChange="pageChange"
			></Page>
			<trigger ref="trigger" @change="getList"></trigger>
		</template>
	</BoxList>
</template>

<script>
import BoxList from "@/components/use/box/BoxList";
import trigger from "./components/trigger";
export default {
	name: "processList",
	components: {
		BoxList,
		trigger,
	},
	data() {
		const vm = this;
		return {
			loading: false,
			channelList: [],
			form: {
				vRepairNo: "",
				vContactName: "",
				vContactTelephone: "",
				vVisitRepairAddress: "",
				channelId: [],
				iAuditStatus: "",
				iRepairStatus: "",
				iBackRepairVisit: "",
				iBackRepairResult: "",
				iBackRepairAudit: "",
				createStartTime: "",
				createEndTime: "",
			},
			formInit: { ...this.form },
			seanchData: {},
			list: [],
			page: {
				count: 0,
				no: 1,
				size: 10,
			},
			time: [],
		};
	},
	mounted() {
		this.getChannelList();
		this.seanch();
	},
	methods: {
		getChannelList() {
			const vm = this;
			this.$http
				.post("/facilityRepairOrder/getChannelInfo")
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						vm.channelList = response.data.body.channels || [];
					} else {
						vm.$message.error(response.data.header.msg);
					}
				})
				.catch(function (error) {
					console.error("获取渠道列表失败:", error);
				});
		},
		timeChange() {
			this.form.createStartTime = this.time && this.time[0] ? this.time[0] : "";
			this.form.createEndTime = this.time && this.time[1] ? this.time[1] : "";
		},
		pageChange(obj) {
			this.page.no = obj.no;
			this.page.size = obj.size;
			this.getList();
		},
		seanch() {
			this.seanchData = { ...this.form };
			this.page.no = 1;
			this.getList();
		},
		getList() {
			const vm = this;
			vm.loading = true;
			let postData = { ...this.seanchData };
			postData.pageIndex = this.page.no;
			postData.pageSize = this.page.size;

			vm.list = [];
			this.$http
				.post(`/facilityRepairOrder/getFacilityRepairOrderPage`, postData)
				.then(function (response) {
					vm.loading = false;
					if (response.data.header.code == "A1000") {
						vm.list = response.data.body.pageInfo.list
							? response.data.body.pageInfo.list
							: [];
						vm.page.count = response.data.body.pageInfo.total;
					} else {
						vm.$message.error(response.data.header.msg);
					}
				})
				.catch(function (error) {
					vm.loading = false;
				});
		},
		rowView(obj) {
			this.$store.commit("addTab", {
				pid: this.$route.path,
				id: "overhaulDetail",
				name: "维修详情",
				url: "/overhaul/overhaulDetail",
				query: {
					type: "view",
					id: obj.pkFacilityRepairOrderId,
				},
			});
		},
		openTrigger(obj) {
			this.$refs.trigger.dialogFormVisible = true;
			this.$refs.trigger.initData(obj.pkFacilityRepairOrderId);
		},
	},
	computed: {
		tableHeight() {
			let height = this.$store.state.tableHeight;
			console.log(height, "tableHeight");
			if (this.$store.state.view == "wap") {
				return 10000;
			} else {
				return height;
			}
		},
	},
	watch: {
		"$store.state.tabs.refresh": function () {
			if (this.$route.path == this.$store.state.tabs.refresh) {
				this.getList();
			}
		},
	},
};
</script>

<style lang="scss" scoped type="text/css"></style>
